export default {
    admin() {
        return [0]
    },
    moderator() {
        return [0, 1]
    },
    accountant() {
        return [0, 2]
    },
    manager() {
        return [0, 3]
    },
    agent() {
        return [0, 1]
    },
    drm() {
        return [0, 6]
    },
    serviceManager() {
        return [0, 7]
    },
    reserve() {
        return [0, 8] 
    },
    support() {
        return [0, 9] 
    },
    mainManager() {
        return [0, 10]
    },
    all() {
        return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    },
    groupSale() {
        return [0, 3, 4, 5, 8]
    },
    groupReserveSale() {
        return [0, 3, 7, 8]
    },
    groupTermination() {
        return [0, 3, 7]
    },
    groupRewrite() {
        return [0, 3, 7]
    },
    groupMainSale() {
        return [0, 3, 4, 7]
    },
    groupSupport() {
        return [0, 9]
    },
    roleName(role) {
        const roles = [
            'Администратор',
            'Модератор',
            'Бухгалтер',
            'Менеджер',
            'Агент',
            'Суб Агент',
            'ДРМ ПОДФТ',
            'Сервис менеджер',
            'Резерв',
            'Тех. поддержка',
            'Главный менеджер'
        ]
        return roles[role]
    },
    allRoles() {
        return [
            {id: 0, name: 'Администратор'},
            {id: 1, name: 'Модератор'},
            {id: 2, name: 'Бухгалтер'},
            {id: 3, name: 'Менеджер'},
            {id: 4, name: 'Агент'},
            {id: 5, name: 'Суб-Агент'},
            {id: 6, name: 'ДРМ ПОДФТ'},
            {id: 7, name: 'Сервис менеджер'},
            {id: 8, name: 'Резерв'},
            {id: 9, name: 'Тех. поддержка'},
            {id: 10, name: 'Главный менеджер'},
        ]
    },
    allRolesToCreate() {
        return [
            {id: 0, name: 'Администратор'},
            {id: 1, name: 'Модератор'},
            {id: 2, name: 'Бухгалтер'},
            {id: 3, name: 'Менеджер'},
            {id: 5, name: 'Суб-Агент'},
            {id: 6, name: 'ДРМ ПОДФТ'},
            {id: 7, name: 'Сервис менеджер'},
            {id: 8, name: 'Резерв'},
            {id: 9, name: 'Тех. поддержка'},
            {id: 10, name: 'Главный менеджер'},
        ]
    },
    rolesFromModerator() {
        return [
            {id: 8, name: 'Резерв'},
        ]
    }
}